import { render, staticRenderFns } from "./XScenenBackground.vue?vue&type=template&id=385b3bc4&"
import script from "./XScenenBackground.vue?vue&type=script&lang=ts&"
export * from "./XScenenBackground.vue?vue&type=script&lang=ts&"
import style0 from "./XScenenBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports